module.exports = __webpack_public_path__ + "img/ruguan.ed819563.png";